import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.rg-slider').forEach(slider => {

        new Swiper(slider, {
            spaceBetween: 24,
            slidesPerView: 1.2,

            navigation: {
                prevEl: slider.parentElement.parentElement.querySelector('.rg-arrow-prev'),
                nextEl: slider.parentElement.parentElement.querySelector('.rg-arrow-next'),
            },

            breakpoints: {
                767: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });

    });

});